module.exports = __webpack_public_path__ + "img/vessel_detail.3c92b86e.svg";